import actions from "./actions";

const stateDefault = {
    documents: [],
    document: {},
};

export default function clientEmployeeDocuments(state = stateDefault, action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_CLIENT_EMPLOYEE_DOCUMENTS:
            return {...state, documents: action.payload};
        case actions.SET_CLIENT_EMPLOYEE_DOCUMENT:
            return {...state, document: action.payload};
        default:
            return state
    }
}
